import {
  ApiUploadtasksListBroDomainEnum,
  ApiUploadtasksListRegistrationTypeEnum,
  ApiUploadtasksListRequest,
  ApiUploadtasksListRequestTypeEnum,
  ApiUploadtasksListStatusEnum,
  UploadTask,
} from "@nens/brostar/openapi-client";

import { SearchOption } from "@/components/searchbox";

const REGISTRATION_TYPE_LABELS: Record<ApiUploadtasksListRegistrationTypeEnum, string> = {
  GMN_StartRegistration: "GMN Start Registratie",
  GMN_MeasuringPoint: "GMN Meetpunt Toevoegen",
  GMN_MeasuringPointEndDate: "GMN Meetpunt Einddatum",
  GMN_TubeReference: "GMN Buisverwijzing",
  GMN_Closure: "GMN Beeindigen",
  GMW_Construction: "GMW Constructie",
  GMW_ElectrodeStatus: "GMW Elektrodestatus",
  GMW_GroundLevel: "GMW Bepaling maaiveld",
  GMW_GroundLevelMeasuring: "GMW Inmeting maaiveld",
  GMW_Insertion: "GMW Buis inplaatsen",
  GMW_Lengthening: "GMW Buis oplengen",
  GMW_Shortening: "GMW Buis inkorten",
  GMW_Positions: "GMW Bepaling posities",
  GMW_PositionsMeasuring: "GMW Inmeting posities",
  GMW_Shift: "GMW Maaiveld verlegd",
  GMW_Maintainer: "GMW Onderhouder",
  GMW_Owner: "GMW Eigenaar",
  GMW_Removal: "GMW Opgeruimd",
  GMW_SubsequentAdditionalSurvey: "GMW Vervolgonderzoek",
  GMW_TubeStatus: "GMW Buisstatus",
  GMW_WellHeadProtector: "GMW Beschermconstructie",
  GAR: "GAR",
  GLD_StartRegistration: "GLD Start Registratie",
  GLD_Addition: "GLD Aanvullen",
  GLD_Closure: "GLD Beeindigen",
  FRD_StartRegistration: "FRD Start Registratie",
  FRD_GEM_MeasurementConfiguration: "FRD GEM Meetconfiguratie",
  FRD_GEM_Measurement: "FRD GEM Meting",
  FRD_EMM_InstrumentConfiguration: "FRD EMM Instrumentconfiguratie",
  FRD_EMM_Measurement: "FRD EMM Meting",
  FRD_Closure: "FRD Beeindigen",
  CPT: "CPT",
  "BHR-P": "BHR-P",
  "BHR-G": "BHR-G",
  "BHR-GT": "BHR-GT",
  SFR: "SFR",
  GUF_StartRegistration: "GUF Start Registratie",
  GUF_NewLicense: "GUF Nieuwe vergunning",
  GUF_ExpandedRealisedInstallation: "GUF Uitgebreide gerealiseerde installatie",
  GUF_WellFunction: "GUF Putfunctie",
  GUF_Height: "GUF Hoogte",
  GUF_Closure: "GUF Beeindigen",
  GUF_AddRealisedInstallation: "GUF Gerealiseerde installatie toevoegen",
  GUF_ClosureRealisedPart: "GUF Gerealiseerd deel beeindigen",
  GPD_StartRegistration: "GPD Start Registratie",
  GPD_AddReport: "GPD Rapport toevoegen",
  GPD_EndRegistration: "GPD Beeindigen",
};

export const registrationTypeOptions = Object.entries(REGISTRATION_TYPE_LABELS).map(
  ([key, label]) => ({ key, label })
);

const REQUEST_TYPE_LABELS: Record<ApiUploadtasksListRequestTypeEnum, string> = {
  registration: "Registratie",
  replace: "Vervanging",
  move: "Bewegen",
  insert: "Invoegen",
  delete: "Verwijderen",
};

export const requestTypeOptions = Object.entries(REQUEST_TYPE_LABELS).map(([key, label]) => ({
  key,
  label,
}));

export const uploadTaskInformation: SearchOption<
  keyof UploadTask | undefined,
  keyof ApiUploadtasksListRequest
>[] = [
  {
    key: "broDomain",
    label: "Domein",
    enum: Object.values(ApiUploadtasksListBroDomainEnum).map((key) => ({ key, label: key })),
  },
  {
    key: "registrationType",
    label: "Registratie",
    enum: registrationTypeOptions,
  },
  {
    key: "requestType",
    label: "Soort",
    enum: requestTypeOptions,
  },
  {
    key: "status",
    label: "Status",
    enum: Object.values(ApiUploadtasksListStatusEnum).map((key) => ({ key, label: key })),
  },
  { key: "broId", searchKey: "broIdIcontains", label: "BRO ID" },
  { key: undefined, searchKey: "requestReferenceIcontains", label: "Referentie" },
];
